import React from 'react'

const TermsAndConditions = () => {
    return (
        <div className="min-h-screen pt-24 pb-20">
            <section className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-5xl font-bold mb-6">
                            Mojo Money Transfer LLC
                        </h1>
                        <p className="text-xl text-emerald-50">
                            Last Updated: November 2025
                        </p>
                    </div>
                </div>
            </section>
            <section>
                <main className="p-8 md:p-12 lg:p-16">
                    <section className="flex flex-col gap-6">

                        <article id="security-policy">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">1. Data Security Policy</h2>

                            <h3 className="text-xl font-bold mb-3 ml-4">1.1 Encryption Standards</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>All data transmissions use TLS 1.2+ (HTTPS).</li>
                                <li>Sensitive data is encrypted at rest using AES-256.</li>
                                <li>Tokenization replaces raw card data with secure tokens.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">1.2 Access Controls</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Role-Based Access (RBAC) ensures only authorized personnel can access sensitive systems.</li>
                                <li>Multi-Factor Authentication (MFA) required for all admin accounts.</li>
                                <li>Audit logs maintained and reviewed monthly or as required.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">1.3 Vulnerability Management</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Regular penetration tests (biannually) using tools like OWASP ZAP and Qualys.</li>
                                <li>Critical security patches applied within 48 hours of disclosure.</li>
                            </ul>
                        </article>

                        <hr />

                        <article id="compliance">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">2. Compliance</h2>

                            <h3 className="text-xl font-bold mb-3 ml-4">2.1 PCI DSS Compliance</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Fully compliant with PCI DSS Level 1 standards.</li>
                                <li>Payments processed by PCI-certified partners (MasterCard, Stripe, PayPal).</li>
                                <li>No raw card data stored on Mojo Money servers.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">2.2 GDPR & Regional Privacy Laws</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Users may request data deletion or portability via support@mojomoneyeth.com.</li>
                                <li>Data stored only in GDPR-compliant regions.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">2.3 Financial Regulations</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Mojo Money Transfer LLC licensed as a Payment Processor/Money Service Business in the US & Ethiopia.</li>
                                <li>Fully compliant with AML (Anti-Money Laundering) and KYC (Know Your Customer) regulations.</li>
                            </ul>
                        </article>

                        <hr />

                        <article id="privacy-policy">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">3. Privacy Policy</h2>

                            <h3 className="text-xl font-bold mb-3 ml-4">3.1 Data Collected</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Personal Data: name, email, phone.</li>
                                <li>Payment Data: tokenized card info handled by third-party gateways.</li>
                                <li>Usage Data: IP address, device type for fraud prevention.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">3.2 Data Usage</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>To process transactions securely.</li>
                                <li>To improve user experience.</li>
                                <li>Never sold to third parties.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">3.3 Third-Party Sharing</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Payment processors (MasterCard, Stripe, etc.).</li>
                                <li>Fraud detection services (e.g., Sift).</li>
                                <li>Legal authorities when required.</li>
                            </ul>
                        </article>

                        <hr />

                        <article id="user-responsibilities">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">4. User Responsibilities</h2>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Use strong passwords and enable MFA.</li>
                                <li>Report suspicious activity to support@mojomoneyeth.com.</li>
                                <li>Avoid sharing login credentials.</li>
                            </ul>
                        </article>

                        <hr />

                        <article id="incident-response">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">5. Incident Response Plan</h2>

                            <h3 className="text-xl font-bold mb-3 ml-4">5.1 Data Breach Protocol</h3>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Contain: isolate affected systems.</li>
                                <li>Notify: report to authorities within 72 hours (GDPR requirement).</li>
                                <li>Communicate: notify users if data is compromised.</li>
                            </ul>

                            <h3 className="text-xl font-bold mb-3 ml-4">5.2 Security Contact</h3>
                            <p className='text-gray-700 leading-relaxed ml-4'>Email: support@mojomoneyeth.com</p>
                            <p className='text-gray-700 leading-relaxed ml-4 mb-3'>Phone: +1 571 447 1503</p>
                        </article>

                        <hr />

                        <article id="aup">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">6. Acceptable Use Policy (AUP)</h2>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>No fraudulent transactions.</li>
                                <li>No reverse-engineering of the app.</li>
                                <li>No exploiting vulnerabilities (report via bug bounty program).</li>
                            </ul>
                        </article>

                        <hr />

                        <article id="audit-updates">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6">7. Audit & Updates</h2>
                            <ul className='text-gray-700 leading-relaxed ml-4 mb-3'>
                                <li>Reviewed annually or after major incidents.</li>
                                <li>Updates communicated via email: info@mojomoneyeth.com.</li>
                            </ul>
                        </article>

                        <footer className="mt-10 text-sm text-gray-500">
                            © {new Date().getFullYear()} Mojo Money. All rights reserved.
                        </footer>
                    </section>
                </main>


            </section>

        </div>
    )
}

export default TermsAndConditions
